// extracted by mini-css-extract-plugin
module.exports = {"toggle":"SwitchButton-module__toggle__3Z6-l","readonly":"SwitchButton-module__readonly__2XnZV"};